import { breakpoints } from '@notino/react-styleguide';

import { css } from '@linaria/core';
import { styled } from '@linaria/react';

import { IExpandableTextProps } from './model';

export const ExpandableTextWrapper = styled.div<
  Pick<IExpandableTextProps, 'isExpanded' | 'height'>
>`
  height: ${({ isExpanded, height }) =>
    isExpanded ? 'auto' : height || '5.5rem'};
  overflow: ${({ isExpanded }) => (isExpanded ? 'initial' : 'hidden')};

  position: relative;
`;

export const mobileWrapperClass = css`
  @media (min-width: ${breakpoints.lg}) {
    height: auto;
    overflow: initial;
  }
`;

export const desktopWrapperClass = css`
  @media (max-width: ${breakpoints.lg}) {
    height: auto;
    overflow: initial;
  }
`;

export const Gradient = styled.div<{ bgColor?: string }>`
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 100%;
  background: ${({ bgColor }) =>
    bgColor
      ? `linear-gradient(
    0deg,
    ${bgColor} 0%,
    transparent 100%
  )`
      : `linear-gradient(
    0deg,
    rgba(255, 255, 255, 1) 0%,
    transparent 100%
  )`};
`;

export const DefaultExpandableTextButton = styled.button`
  background: none;
  border: none;
  text-decoration: underline;
  cursor: pointer;
  padding: 0.5rem 0;
  color: #000;
`;
